const paidReferralSubscriptionBonus = 100;
const convertLimitPrice = 1;
const customVoiceLimitPrice = 50;

export const $creditPriceList = {
  paidReferralSubscriptionBonus,
  convertLimitPrice,
  customVoiceLimitPrice,
};
